import React from "react";
import * as validate from "../../Components/Modals/validations";
import { params, const_var } from "../../redux/reducers/reducer";
import * as cuBuilding from "../../redux/reducers/building_pricing/pricingReducer";
import * as cuComponent from "../../redux/reducers/building_component/componentReducer";
export const resetBuildingView = () => {
	if (params.isShowCenter || params.is_translusant) {
		params.isShowCenter = false;
		params.is_translusant = false;
		cuBuilding.BuildingUpdate(true);
		if (params.add_front_lean) cuBuilding.UpdateFrontLean();
		if (params.add_left_lean) cuBuilding.UpdateLeftLean();
		if (params.add_right_lean) cuBuilding.UpdateRightLean();
		if (params.add_back_lean) cuBuilding.UpdateBackLean();
	}
};

export const resetCameraPosition = () => {
	const_var.controls.target.set(0, params.p_h / 2, 0);
	const_var.camera.position.set(0, params.p_h + 0, 3.25 * params.p_d);
	const_var.controls.update();
};

export const handleMobileThumbView = () => {
	const checkBodyThyumb = document.querySelector("body");
	if (checkBodyThyumb.classList.contains("activethumb-view")) {
		checkBodyThyumb.classList.remove("active-offset-thumbnail");
		if (const_var.ClickforPhotosMobile == false) {
			const_var.ClickforPhotosMobile = React.createRef();
			setTimeout(() => {
				const_var.ClickforPhotosMobile.current.click();
			}, 100);
		}
		setTimeout(() => {
			const_var.activeTab = "buildingtypetab";
			cuComponent.TsCeSot("quote");
		}, 500);
	} else {
		const_var.activeTab = "buildingtypetab";
		cuComponent.TsCeSot("quote");
	}
};

export const setLeantoAlignment = () => {
	const leanto = const_var?.post_data["building"]?.leanto;
	if (!leanto || leanto.length === 0) return;

	for (let i = 0; i <= leanto.length - 1; i++) {
		if (leanto[i].leanto_type == 1) {
			leanto[i].alignment = const_var.TypeAlingnment[params.leantoAlignmentLeft];
		}
		if (leanto[i].leanto_type == 2) {
			leanto[i].alignment = const_var.TypeAlingnment[params.leantoAlignmentRight];
		}
		if (leanto[i].leanto_type == 3) {
			leanto[i].alignment = const_var.endLeanAlingnmentType[params.leantoAlignmentFront];
		}
		if (leanto[i].leanto_type == 4) {
			leanto[i].alignment = const_var.endLeanAlingnmentType[params.leantoAlignmentBack];
		}
	}
};

export const prepareQuotePostData = () => {
	const building = const_var.post_data["building"];
	if (building && building.other_building_type_name === "") {
		params.other_building_type_name = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
		building.other_building_type_name = params.other_building_type_name;
		building.name = params.other_building_type_name;
	}
	setLeantoAlignment();
	if (building && building.surcharge_amount != 0) {
		building.surcharge_taxable = building?.surcharge_taxable ?? 0;
	}
	building.is_showBackgroundImage = const_var.crmSetting.is_show_background;
	building.tax_zipcode = const_var.post_data["billing_zipcode"];
	building.custom_building = const_var.hide_price_calculation;
	building.payment_mode = const_var.paymentOptionObj[params.paymentmode];
	building.other_building_type_name = params.other_building_type_name;
	building.name = params.other_building_type_name;
	const_var.post_data["name"] = building.other_building_type_name;
	const_var.post_data["custom_building"] = const_var.hide_price_calculation;
	const_var.post_data["is_quote"] = 1;
	const_var.post_data["charge_card"] = 0;
	const_var.post_data["questions"] = const_var.estimator_QuestionAnswer;
	const_var.post_data["module"] = "quote";
	const_var.post_data["module_id"] = "";
	const_var.post_data["sub_module"] = "";
	const_var.post_data["sub_module_id"] = "";
	const_var.post_data["form_type"] = "3d_v4";
	const_var.post_data["building_data"]["color_data"] = const_var?.color;
	const_var.post_data["building_data"]["component_data"] = const_var.componentData;
	const_var.post_data["building_data"]["siding_material_data"] = const_var.mainSidingOptions;
	const_var.post_data["created_source"] = "3d_v4";
	const_var.post_data["pdf_price_breakdown"] = const_var.price_breakdown_key[const_var.crmSetting.is_module_name];
	const_var.post_data["is_api"] = 1;
	const_var.post_data["lead_source"] = "3D Estimator";
	const_var.post_data["referral_source"] = const_var.referrer == "" ? document.referrer : const_var.referrer;
	if (const_var?.crmSetting?.utm_medium) {
		const_var.post_data["utm_medium"] = const_var.crmSetting.utm_medium;
	}
	if (const_var?.crmSetting?.utm_term) {
		const_var.post_data["utm_term"] = const_var.crmSetting.utm_term;
	}
	if (const_var?.crmSetting?.utm_campaign) {
		const_var.post_data["utm_campaign"] = const_var.crmSetting.utm_campaign;
	}
	if (const_var?.crmSetting?.utm_content) {
		const_var.post_data["utm_content"] = const_var.crmSetting.utm_content;
	}
	const_var.post_data["source"] = const_var?.crmSetting?.utm_source || const_var?.crmSetting?.source;
	const_var.post_data["build_type"] = "added_building";
	const_var.post_data["page"] = const_var.crmSetting.page;
	const_var.post_data["form"] = "Quote Form";
	building.surface_level = params.job_site_level;
	building.electricity = params.power_avail;
	building.additional_note = params.additional_note;
	const_var.post_data["api_token"] = const_var.crmSetting.api_token;
	const_var.post_data["building_data"] = const_var.SendAPIBuildingData;
	const_var.post_data["pricing_data"] = const_var.isLTBuilding ? const_var.holdPricingResponse : const_var.a_p_d_a;
	const_var.post_data["estimator_domain"] = const_var.crmSetting?.main_domain_url;
	if (const_var.referralID != "") {
		const_var.post_data["referral_id"] = const_var.referralID;
		const_var.post_data["lead_source"] = "3D Estimator Referral";
	}
};
export const editOldQuotes = (response, is_check, priceresponse, response1) => {
	if ((response.data.data.request_data.building.manufacturer == 2 || response.data.data.request_data.building.manufacturer == 17) && response1 !== undefined) {
		response.data.data.building_data.building = response1.data.data.building;
		response.data.data.building_data.default_building = response1.data.data.default_building;
	}
	let editBuildingData = response.data.data.request_data.building;
	let buildingData = response.data.data.building_data.building;
	let buildingIndex = null;
	let filterBuilding = buildingData.filter((building, index) => {
		if (building.building_type.building_id === editBuildingData.building_type) {
			buildingIndex = index;
			return building;
		}
	});
	if (filterBuilding[0]?.fixed_new_leg_width?.length >= 0) return;

	filterBuilding.forEach((building) => {
		if (building.building_type.building_id === editBuildingData.building_type) {
			if (building.fixed_new_leg_width !== undefined && building.fixed_new_leg_width.length > 0 && building.fixed_new_leg_width[0][editBuildingData.width] == undefined) {
				building.fixed_new_leg_width = [];
			}
			if (building.fixed_new_leg_width !== undefined && building.fixed_new_leg_width.length > 0 && building.fixed_new_leg_width[0][editBuildingData.height] == undefined) {
				building.fixed_new_leg_width = [];
			}
			if (building.fixed_new_leg_width !== undefined && building.fixed_new_leg_width.length > 0 && building.fixed_new_leg_width[0][editBuildingData.length] == undefined) {
				building.fixed_new_leg_width = [];
			}
		}
	});

	if (is_check != undefined && is_check == "edit") {
		const_var.oldFreeStandingData = undefined;
	}
	if (const_var.oldFreeStandingData === undefined && (filterBuilding[0].fixed_new_leg_width === undefined || filterBuilding[0].fixed_new_leg_width.length === 0)) {
		const_var.oldFreeStandingData = JSON.parse(JSON.stringify(response));
		if (filterBuilding.length > 0) {
			let filterRoofStyle = filterBuilding[0].roof_style.filter((roof) => {
				if (roof.roof_id === editBuildingData.roof_style) {
					return roof;
				}
			});
			let defaultBuildingDataFilter = response.data.data.building_data.default_building.filter((item) => {
				if (item.building_id === editBuildingData.building_type || item.name.includes("Free Standing Lean-to") || item.name.includes("Free Standing Building")) {
					return item;
				}
			});
			defaultBuildingDataFilter.forEach((item) => {
				item.size = `${editBuildingData.width}x${editBuildingData.length}x${editBuildingData.height}`;
				item.central_roof_pitch = editBuildingData.roof_pitch;
			});
			filterRoofStyle[0].min_height = editBuildingData.height;
			filterRoofStyle[0].max_height = editBuildingData.height;
			filterRoofStyle[0].start_height = editBuildingData.height;

			filterRoofStyle[0].min_start_width = editBuildingData.width;
			filterRoofStyle[0].min_width = editBuildingData.width;
			filterRoofStyle[0].max_width = editBuildingData.width;

			filterRoofStyle[0].start_length = editBuildingData.length;
			filterRoofStyle[0].min_start_length = editBuildingData.length;
			filterRoofStyle[0].end_length = editBuildingData.length;
			filterRoofStyle[0].building_max_length = editBuildingData.length;
			filterRoofStyle[0].default_gauge = editBuildingData.gauge;
			filterBuilding[0].roof_style = filterRoofStyle;
			buildingData.forEach((building) => {
				if (
					(building.building_type.name.includes("Free Standing Lean-to") || building.building_type.name.includes("Free Standing Building")) &&
					(building?.fixed_new_leg_width !== undefined || building?.fixed_new_leg_width == 0)
				) {
					building.roof_style = filterRoofStyle;
				}
			});
		}
		let filterRoofpitch = response.data.data.pricing_data.roof_pitch.filter((roof) => {
			if (roof.roof_pitch == editBuildingData.roof_pitch) {
				return roof;
			}
		});

		response.data.data.pricing_data.roof_pitch = filterRoofpitch;

		let filterGauge = response.data.data.pricing_data.base.filter((base) => {
			if (base.gauge === editBuildingData.gauge) {
				return base;
			}
		});

		response.data.data.pricing_data.roof_pitch[0].is_default = "yes";
		response.data.data.pricing_data.base = filterGauge;
		response.data.data.pricing_data.building_structure[0] = filterBuilding[0].roof_style[0];
		response.data.data.building_data.building[buildingIndex] = filterBuilding[0];

		if (is_check != undefined && is_check == "edit" && priceresponse !== null) {
			priceresponse.data.data.base = filterGauge;
			priceresponse.data.data.building_structure[0] = filterBuilding[0].roof_style[0];
			priceresponse.data.data.roof_pitch = response.data.data.pricing_data.roof_pitch;
		}
		const_var.infoMessage = true;
	} else {
		let checkBuildingType =
			(response.data.data.request_data != undefined && response.data.data.request_data.building.display_building_type_name.includes("Free Standing Buildings")) ||
			response.data.data.request_data.building.display_building_type_name.includes("Free Standing Lean-to");
		if (!checkBuildingType && filterBuilding[0].fixed_new_leg_width?.length === 0 && const_var.oldFreeStandingData !== undefined && filterBuilding.length > 0) {
			const_var.AllBuildingData.data = const_var.oldFreeStandingData.data.data.building_data;
			const_var.editAPIDataByResponse.data.building_data = const_var.oldFreeStandingData.data.data.building_data;
			let oldVarData = const_var.AllBuildingData?.data?.building?.filter((building) => {
				if (building.building_type.building_id === params.p_b_t) {
					return building;
				}
			});
			if (oldVarData.length > 0) {
				const_var.c_m_a[params.p_b_t].roof_style = oldVarData[0].roof_style;
			}
			const_var.infoMessage = false;
		}
	}
	return response;
};